import playoffCaptainAPI from '../../../utils/playoffCaptainAPI';
import toolkitApi, { toolkitSimpleTransform } from '../../toolkitApi';
import { mergeCaptainData } from '../awards/selectors';

import {
    awardCategoriesEndpoint,
    awardsForFranchiseEndpoint,
    franchiseTrophyCategoriesEndpoint,
} from './franchiseAwardAPI';
import selectors from './selectors';

export default toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        awardCategories: build.query({
            query: (id) => ({
                url: awardCategoriesEndpoint(id),
            }),
            transformResponse: selectors.getAwardCategories,
        }),
        franchiseTrophyCategories: build.query({
            query: () => ({
                url: franchiseTrophyCategoriesEndpoint,
            }),
            transformResponse: toolkitSimpleTransform,
        }),
        franchiseAwards: build.query({
            async queryFn(args, queryApi, extraOptions, fetchWithBQ) {
                const { franchiseId, trophyCategory } = args;
                if (!trophyCategory) {
                    return {
                        data: {},
                    };
                }

                const [{ data: franchiseAwardData }, { data: playoffCaptains }] = await Promise.all([
                    fetchWithBQ(awardsForFranchiseEndpoint(franchiseId, trophyCategory)),
                    fetchWithBQ(playoffCaptainAPI.playoffCaptainEndpoint),
                ]);
                mergeCaptainData(franchiseAwardData.data, playoffCaptains.data);

                const trophies = selectors.groupFranchiseTrophies(franchiseAwardData.data);
                return {
                    data: {
                        trophyCategory,
                        trophies,
                    },
                };
            },
        }),
    }),
});
